var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/moneys"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0834 6.59632V10.888C16.0834 13.4547 14.6167 14.5546 12.4167 14.5546H5.09171C4.71671 14.5546 4.35838 14.5214 4.02504 14.4464C3.81671 14.413 3.61672 14.3547 3.43339 14.288C2.18339 13.8214 1.42505 12.738 1.42505 10.888V6.59632C1.42505 4.02966 2.89171 2.92969 5.09171 2.92969H12.4167C14.2834 2.92969 15.625 3.72135 15.9834 5.52968C16.0417 5.86302 16.0834 6.20466 16.0834 6.59632Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5843 9.09789V13.3896C18.5843 15.9562 17.1177 17.0562 14.9177 17.0562H7.59267C6.976 17.0562 6.41767 16.9729 5.93434 16.7896C4.94267 16.4229 4.26767 15.6646 4.026 14.4479C4.35933 14.5229 4.71767 14.5562 5.09267 14.5562H12.4177C14.6177 14.5562 16.0843 13.4562 16.0843 10.8896V6.59789C16.0843 6.20622 16.051 5.85625 15.9843 5.53125C17.5677 5.86458 18.5843 6.98122 18.5843 9.09789Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.74872 10.9469C9.96374 10.9469 10.9487 9.96191 10.9487 8.74689C10.9487 7.53186 9.96374 6.54688 8.74872 6.54688C7.53369 6.54688 6.54871 7.53186 6.54871 8.74689C6.54871 9.96191 7.53369 10.9469 8.74872 10.9469Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.9834 6.91406V10.5807",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5182 6.91406V10.5807",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositSelectedIcon);
export default __webpack_public_path__ + "static/media/deposit-selected-icon.37f3ebe71c3d457f267edeefaf488626.svg";
export { ForwardRef as ReactComponent };